"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ScreenRelinkRentPortalAddressAnalyticsEvent = exports.ScreenRelinkOonHowYouPayAnalyticsEvent = exports.ScreenRelinkOonHowFlexWorksAnalyticsEvent = exports.ScreenRelinkConfirmAddressAnalyticsEvent = exports.ScreenRelinkAddressUnitSelectionAnalyticsEvent = exports.ScreenRelinkAddressSelectionAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user views the 'Search for your property' screen in the Relink Flow
 */
var ScreenRelinkAddressSelectionAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_relink_address_selection');
exports.ScreenRelinkAddressSelectionAnalyticsEvent = ScreenRelinkAddressSelectionAnalyticsEvent;
/**
 * Triggers when user sees the unit selection screen 'Which unit do you live in' in the Relink Flow
 */
var ScreenRelinkAddressUnitSelectionAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_relink_address_unit_selection');
exports.ScreenRelinkAddressUnitSelectionAnalyticsEvent = ScreenRelinkAddressUnitSelectionAnalyticsEvent;
/**
 * Triggers when user views the 'Confirm your address' screen in the Relink Flow
 */
var ScreenRelinkConfirmAddressAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_relink_confirm_address');
exports.ScreenRelinkConfirmAddressAnalyticsEvent = ScreenRelinkConfirmAddressAnalyticsEvent;
/**
 * Triggers when customer views the Flex Anywhere 'What's your address' screen in the Relink Flow
 */
var ScreenRelinkRentPortalAddressAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_relink_rent_portal_address');
exports.ScreenRelinkRentPortalAddressAnalyticsEvent = ScreenRelinkRentPortalAddressAnalyticsEvent;
/**
 * Triggers when user views the Flex Anywhere Introduction Screen in the Relink Flow
 */
var ScreenRelinkOonHowYouPayAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_relink_oon_how_you_pay');
exports.ScreenRelinkOonHowYouPayAnalyticsEvent = ScreenRelinkOonHowYouPayAnalyticsEvent;
/**
 * Triggers when customer views the Flex Anywhere How It Works screen in the Relink Flow
 */
var ScreenRelinkOonHowFlexWorksAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_relink_oon_how_flex_works');
exports.ScreenRelinkOonHowFlexWorksAnalyticsEvent = ScreenRelinkOonHowFlexWorksAnalyticsEvent;
